import { render, staticRenderFns } from "./CandidateContact.vue?vue&type=template&id=11071554&scoped=true&"
import script from "./CandidateContact.vue?vue&type=script&lang=js&"
export * from "./CandidateContact.vue?vue&type=script&lang=js&"
import style0 from "./CandidateContact.vue?vue&type=style&index=0&id=11071554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11071554",
  null
  
)

/* custom blocks */
import block0 from "./CandidateContact.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CandidateContact.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports